var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRechargeLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 80 80"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#rechargeLogo_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#3901F1",
  d: "M39.996 79.992c22.09 0 39.996-17.907 39.996-39.996S62.085 0 39.996 0 0 17.907 0 39.996s17.907 39.996 39.996 39.996"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFBF6",
  d: "M43.814 55.84H23.988a.414.414 0 0 1-.415-.495l3.865-19.849a.384.384 0 0 1 .682-.149l16 19.85a.42.42 0 0 1 .022.404.42.42 0 0 1-.328.238M23.62 25.87h19.826a.416.416 0 0 1 .415.494L40.02 46.252a.4.4 0 0 1-.293.288.39.39 0 0 1-.39-.13L23.315 26.49a.369.369 0 0 1 .306-.62M45.844 25.87a.41.41 0 0 0-.384.297 11.85 11.85 0 0 0 6.782 12.234c1.514.7 3.16 1.073 4.828 1.093h.416a.36.36 0 0 0 .376-.306l2.666-12.895a.42.42 0 0 0-.416-.455z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "rechargeLogo_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h80v80H0z"
})))));
export default SvgRechargeLogo;